import lang from "@/views/modules/Notifications/language/en";

let searchFieldsDef = {
    'created_by': {
        label: lang.LBL_CREATED_BY,
        type:'selectcomponent',
        route: 'users',
        moduleName: 'Users',
        name: 'noti_user_name',
        id: 'noti_created_by',
    },
    'read': {
        label: lang.LBL_READ,
        type:'select',
        field_infos:'read_unread_dom'
    },
    'description': {
        label: lang.LBL_DESCRIPTION,
    },
    'parent_type': {
        label: lang.LBL_PARENT_TYPE,
    },
    'date_entered': {
        label: lang.LBL_CREATE_DATE,
        type:'daterange',
    },
};
export default { searchFieldsDef }